<template>
  <div>
    <v-container
      grid-list-xl
      fluid
    >
      <v-layout
        row
        wrap
        class="mt-4"
      >
        <v-toolbar
          flat
          color="transparent"
          class="mb-4 mt-4"
          height="20px"
        >
          <v-btn
            icon
            class="text--secondary"
            @click="goBack"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <span class="text-capitalize subheading text--secondary">
            {{ $t('Settings') }}
          </span>
        </v-toolbar>
        <v-flex xs12>
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              md4
              offset-md1
            >
              <div>
                <h3 class="title font-weight-regular pt-3">
                  {{ $t('Shipping methods') }}
                </h3>
              </div>
              <v-layout wrap>
                <v-flex
                  xs12
                  px-0>
                  <v-btn
                    @click="selectMethod('__')"
                  >
                    {{ $t('Add shipping method') }}
                  </v-btn>
                </v-flex>
                <v-flex
                  xs12
                  px-0
                  py-0>
                  <v-btn
                    @click="reindex()"
                  >
                    {{ $t('Reindex methods') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              xs12
              md6
            >
              <LoadingState
                v-if="loading"
                :loading="loading"
              />
              <ShippingList
                v-else
                :methods="methods"
                @selectMethod="selectMethod"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <template
      v-if="dialog"
    >
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <ShippingMethodForm
            v-if="selectedMethod"
            :method="selectedMethod"
          />
          <template v-else>
            <v-card-title />
            <loading-state
              :loading="true"
            />
          </template>
          <v-card-actions>
            <v-btn
              v-if="selectedMethod && !selectedMethod.isNew"
              color="darken-1"
              flat
              small
              @click="deleteShippingMethod"
            >
              {{ $t('Delete') }}
            </v-btn>

            <v-spacer />
            <v-btn
              color="darken-1"
              flat
              small
              @click="closeShippingMethodDialog"
            >
              {{ $t('Close') }}
            </v-btn>
            <v-btn
              color="primary darken-1"
              flat
              small
              @click="saveShippingMethod"
            >
              {{ $t('Save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import LoadingState from '@/components/LoadingState'
import ShippingList from '@/modules/Settings/components/Shippings/ShippingList.vue'
import ShippingMethodForm from '@/modules/Settings/components/Shippings/ShippingMethodForm'

export default {
  name: 'SettingsShipping',

  components: {
    LoadingState,
    ShippingList,
    ShippingMethodForm
  },

  actionBar () {
    return {
      title: 'Shipping Settings'
    }
  },

  data () {
    return {
      loading: false,
      dialog: false,
      selectedMethod: null,
      methods: [],
      taxes: [],
      taxesSettings: {}
    }
  },

  async created () {
    await this.setMethods()
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'settings' })
    },

    async setMethods () {
      this.loading = true
      this.methods = await this.$http.make('shipping').get()
      this.loading = false
    },

    async selectMethod (method) {
      this.selectedMethod = null
      let fetchedMethod = null
      this.dialog = true
      if (method !== '__') {
        fetchedMethod = method
      } else {
        fetchedMethod = await this.$http.make('shipping')
        fetchedMethod.isNew = true
      }
      this.selectedMethod = fetchedMethod
    },

    async saveShippingMethod () {
      if (this.selectedMethod.isNew && !this.selectedMethod.code) {
        this.selectedMethod.errors = [{ field: 'method.code', message: [this.$t('Provide code name')] }]
        this.$toast.error(this.$t('Provide code name'))
        return
      }

      this.selectedMethod.save().then(() => {
        this.$toast.success(this.$t('Shipping method saved'))
        this.closeShippingMethodDialog()
        this.setMethods()
      }).catch(e => {
        this.$toast.error(this.$t(e.message))
      })
    },

    async deleteShippingMethod () {
      this.selectedMethod.delete()
        .then(() => {
          this.selectedMethod = null
          this.dialog = false
          this.$toast.success(this.$t('Shipping method has been deleted'))
          this.setMethods()
        })
        .catch(e => {
          this.$toast.error(this.$t(e.message))
          this.closeShippingMethodDialog()
        })
    },

    reindex () {
      this.$http.make('shipping').reindex().then(() => {
        this.$toast.success(this.$t('Shipping methods reindex started.'))
        this.setMethods()
      })
    },

    closeShippingMethodDialog () {
      this.selectedMethod = null
      this.dialog = false
    }
  }
}
</script>
